import { Box, TextInputNew } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { tableItemStrings } from '../../../data/static/strings'

export const RenderRefuntProcessView: FC = ({ onChangeInput, entry, data, isRowChecked }) => {
  const [value, setValue] = useState(entry)

  const validateInput = (changedValue: string, maxValue: number): string => {
    if (+changedValue > maxValue) {
      return tableItemStrings.invalidAmount
    }
    return ''
  }

  const amount = data?.amount?.split(' ')[1] ?? data?.amount
  const refundAmount = data?.refundAmount?.split(' ')[1] ?? data?.refundAmount

  const onChangeText = (text: string) => {
    const enteredValue: string = text ? text.trim() : ''
    let finalText: any = enteredValue
    //const decimalRegex = /^\d*\.?\d{1,2}$/ // 12.23 => true
    const onlyNumberAndDecimalRegex = /^[0-9.]*$/ // 12.23 => true
    const splitList = enteredValue.split('.')

    if (splitList.length === 2 && splitList[1].length > 2) {
      return false
    }
    // filter only number and dot
    if (onlyNumberAndDecimalRegex.test(enteredValue)) {
      setValue(finalText)
      if (onChangeInput) {
        onChangeInput(data?.rrn, text)
      }
    }
    // set empty string while clear amount
    else if (enteredValue.length === 0) {
      setValue(finalText)
      if (onChangeInput) {
        onChangeInput(data?.rrn, text)
      }
    }
  }

  return (
    <Box borderWidth={1} borderRadius={4} ph={4} pv={6} borderColor={'DISABLED_GREY'} bg={'WHITE'}>
      <TextInputNew
        value={value ?? ''}
        onChangeText={onChangeText}
        //onKeyPress={(eve) => console.log('evem2', eve.target.valueOf())}
        error={validateInput(entry, +amount - +refundAmount)}
        touched
        type={'body14'}
        showBottomLine={false}
        focusBorderColor={'TRANSPARENT'}
        textAlign={'center'}
        testID="refundInput"
        editable={isRowChecked}
      />
    </Box>
  )
}
